import { ajax } from "jquery";
import 'slick-carousel';

import '../../themes/historia-do-whisky.css'

jQuery(async function () {
  $('.cards-historia-whisky-carousel').slick({
      dots: false,
      arrows: false,
      infinite: false,
      autoplay: false,
      speed: 300,
      slidesToShow: 3,
      touchThreshold: 1000,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            dots: true,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            dots: true,
          }
        }
      ]
  });
})
